export function bx_sliders () {
    const windowWidth = $(window).width(); //do not remove.. used in bxSlider

   //home about microsites carousel
    const micrositeSlider = $('#microsites_carousel .microsites_carousel_wrap').bxSlider({
      slideWidth: (windowWidth < 998) ? 320 : 250,
      adaptiveHeight: false,
      minSlides: 1,
      maxSlides: (windowWidth < 998) ? 1 : 4,
      moveSlides: 1,
      shrinkItems: true,
      slideMargin: 0,
      infiniteLoop: true,
      pager: false,
      auto: false,
      useCSS: false,
      hideControlOnEnd: true,
    });

    //banners carousel
    const bannerSlider = $('#banners_carousel .banners_carousel_wrap').bxSlider({
      slideWidth: (windowWidth < 998) ? 320 : 250,
      adaptiveHeight: false,
      minSlides: 1,
      maxSlides: (windowWidth < 998) ? 1 : 6,
      moveSlides: 1,
      shrinkItems: true,
      slideMargin: 0,
      infiniteLoop: true,
      pager: false,
      auto: false,
      useCSS: false,
      hideControlOnEnd: true,
    });

    //service carousel
    const serviceSlider = $('#services #service_carousel_wrap').bxSlider({
      slideWidth: 390,
      adaptiveHeight: true,
      minSlides: 1,
      maxSlides: (windowWidth < 998) ? 1 : 4,
      moveSlides: 1,
      shrinkItems: true,
      slideMargin: 0,
      infiniteLoop: true,
      pager: false,
      auto: false,
      useCSS: false,
      hideControlOnEnd: true,
    });

    // reviews slider
    const reviewSlider = $('.bxreviews').bxSlider({
      // slideWidth: 500,
      adaptiveHeight: true,
      slideMargin: 0,
      minSlides: 1,
      maxSlides: 1,
      shrinkItems: true,
      controls: true,
      nextText: '<i class="fas fa-chevron-right"></i>',
      prevText: '<i class="fas fa-chevron-left"></i>',
      infiniteLoop: true,
      pager: false,
      auto: false,
      useCSS: false,
      speed: 3,
    });

    //blog carousel
    const newsSlider = $('#news-and-updates #news_carousel_wrap').bxSlider({
      slideWidth: 370,
      adaptiveHeight: false,
      minSlides: 1,
      maxSlides: (windowWidth < 998) ? 1 : 3,
      moveSlides: 1,
      shrinkItems: false,
      slideMargin: 15,
      infiniteLoop: true,
      pager: false,
      auto: false,
      useCSS: false,
      hideControlOnEnd: true,
    });

    //reload slider on window resize
    $(window).on('resize', function () {
        if ( $('#microsites_carousel').length ) micrositeSlider.reloadSlider();
        if ( $('#banners_carousel').length ) bannerSlider.reloadSlider();
        if ( $('#bxreviews').length ) reviewSlider.reloadSlider();
        if ( $('#services').length ) serviceSlider.reloadSlider();
        if ( $('#news-and-updates').length ) newsSlider.reloadSlider();
    })

}



// WEBPACK FOOTER //
// ./scripts/includes/bx_sliders.js